import { useEffect, useState } from "react"
import API from "./API"
import { AdminQueryOrder, AdminQueryProject } from "../../backend/src/api/dto"
import { lookupNameFromObjectsArray } from "./global"
import { Link } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { yesNo } from "./constants"

function Orders() {

    const [data, setData] = useState<{
        orders: AdminQueryOrder[],
        projects: AdminQueryProject[]
    }>({
        orders: [],
        projects: []
    })

    useEffect(() => {
        Promise.all([

            API.getOrders(),
            API.getProjects({}),
        ]).then(res => {
            setData({
                orders: res[0],
                projects: res[1]
            })
        })
    }, [])


    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ height: '55px' }}>
                    <h5 className="mt-2">
                        <FontAwesomeIcon fixedWidth icon={["fas", "money-check"]} /> Zákazky
                    </h5>
                </div>
                <div className="card-body">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Komponent</th>
                                <th>Projekt</th>
                                <th>Popis</th>
                                <th>Aktivity</th>
                                <th className="text-center" style={{ width: '110px' }}>Akcia</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.orders.map(order => {
                                    return (
                                        <tr>
                                            <td>{order.name}</td>
                                            <td>{lookupNameFromObjectsArray(data.projects, 'projectId', order.projectId)}</td>
                                            <td>{order.description}</td>
                                            <td>{lookupNameFromObjectsArray(yesNo, 'id', order.withActivities)}</td>
                                            <td className="text-center"><Link className="btn btn-primary btn-sm" to={"/dashboard/center/" + order.orderId}><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</Link></td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Orders